<div class="flex-fill d-flex flex-column">
    <div class="column ms-2 me-3"><span class="color-legend with-border acknowledged"></span> - Acknowledged</div>
    <div *ngIf="reviews" class="m-1 grid-fill" style="max-width: 100%">
        <dx-data-grid
            #dataGrid
            [dataSource]="reviews"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="id" width="80"></dxi-column>
            <dxi-column dataField="created" width="80" [sortIndex]="1" sortOrder="desc"></dxi-column>
            <dxi-column dataField="purchased" width="80"></dxi-column>
            <dxi-column dataField="vIN" caption="VIN" width="150"></dxi-column>
            <dxi-column dataField="dealerName" width="200"></dxi-column>
            <dxi-column dataField="customerName" caption="Customer" width="200"></dxi-column>
            <dxi-column dataField="address" width="200" [encodeHtml]="false"></dxi-column>
            <dxi-column dataField="email" width="200"></dxi-column>
            <dxi-column dataField="phone" width="200"></dxi-column>
            <dxi-column dataField="orderLineDetailId" width="80"></dxi-column>
            <dxi-column dataField="orderLineDetail.built" caption="Built" width="80"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.order.invoiceNumber" caption="SO#" width="80"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.order.dealerId" caption="Dealer Id" width="100"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.order.dealer.companyName" caption="Azure Dealer Name" width="180"></dxi-column>
            <dxi-column dataField="isAcknowledged" width="180" [sortIndex]="0" sortOrder="asc"></dxi-column>
            <dxi-column width="200"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="warranty-registrations-grid"></dxo-state-storing>
            <dxo-selection mode="multiple"></dxo-selection>
            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-sm btn-success ms-2"
                    (click)="acknowledgeRegistration()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    Acknowledge
                </button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="deleteRegistration(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Delete
                </button>
                <button
                    class="btn btn-sm btn-secondary ms-2"
                    (click)="assignToDetail(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Assign to Detail
                </button>
                <button class="btn btn-sm btn-secondary ms-4" (click)="getData()">Refresh Data</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="reviews" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
